import YandexMapModal from './YandexDeliveryWidget'

export default YandexMapModal